// prettier-ignore-file
import React, { useState } from 'react';
import PageWrapper from '../layout/PageWrapper/PageWrapper';
import Page from '../layout/Page/Page';
import Button from '../components/bootstrap/Button';
import Card, { CardBody } from '../components/bootstrap/Card';

const PrivacyPolicy = () => {
	const [title] = useState({ title: 'Privacy Policy' });

	return (
		<PageWrapper title={title.title}>
			<Page>
				<Card shadow='sm' style={{ width: '100%', borderSize: '2px' }}>
					<CardBody>
						<h1>Privacy Policy</h1>
						<p>Last updated: October 26, 2023</p>

						<p>
							This Privacy Policy describes how PT. Lautan Natural Krimerindo ("we,"
							"us," or "our") collects, uses, and shares information when you use our
							mobile application, Ellenka Squad (the "App"). Your privacy is important
							to us. Please read this policy carefully.
						</p>

						<h2>1. Information We Collect</h2>
						<p>
							We do NOT collect any health or medical data through the Ellenka Squad
							app.
						</p>
						<p>
							This App is not intended for children under 13. We do not knowingly
							collect personal information from children under 13. If we become aware
							that we have collected personal information from a child under 13
							without verifiable parental consent, we will take steps to delete that
							information. If you believe we might have any information from or about
							a child under 13, please contact us at mis.stf02@lnk.co.id.
						</p>
						<p>We may collect the following types of information:</p>
						<ul>
							<li>
								<b>Information You Provide:</b> Any information you voluntarily
								provide to us, such as your name, email address, or other contact
								information when you contact us.
							</li>
							<li>
								<b>Device Information:</b> Information about your device, including
								device type, operating system, unique device identifiers, IP
								address, and other diagnostic data.
							</li>
							<li>
								<b>Usage Data:</b> Information about how you use the App, including
								features accessed, pages visited, and the time and date of your
								visits.
							</li>
							<li>
								<b>Location Information (Only with Your Permission):</b> We may
								request access to your device's location for specific features. You
								can control this access through your device settings.
							</li>
							<li>
								<b>Camera and Photo Library Access (Only with Your Permission):</b>{' '}
								We may request access to your camera and photo library for specific
								features. You can control this access through your device settings.
							</li>
						</ul>

						<h2>2. How We Use Your Information</h2>
						<p>We use the information we collect to:</p>
						<ul>
							<li>Provide, maintain, and improve the App.</li>
							<li>Respond to your inquiries and provide customer support.</li>
							<li>Analyze usage trends and improve App performance.</li>
							<li>
								Protect against, identify, and prevent fraud and other illegal
								activity.
							</li>
							<li>Comply with applicable legal obligations.</li>
						</ul>

						<h2>3. How We Share Your Information</h2>
						<p>We may share your information with:</p>
						<ul>
							<li>
								<b>Service Providers:</b> Third-party service providers who assist
								us with data analytics, customer support, and hosting services.
								These providers are contractually obligated to protect your
								information.
							</li>
							<li>
								<b>Business Transfers:</b> In the event of a merger, acquisition, or
								sale of assets, your information may be transferred. We will notify
								you of any such change.
							</li>
							<li>
								<b>Legal Requirements:</b> When required by law or in response to a
								valid legal request.
							</li>
						</ul>

						<h2>4. Data Security</h2>
						<p>
							We take reasonable measures to protect your information, but no method
							of transmission over the internet is 100% secure.
						</p>

						<h2>5. Children's Privacy</h2>
						<p>
							Our App is not intended for children under 13. We do not knowingly
							collect information from children under 13.
						</p>

						<h2>6. Changes to this Privacy Policy</h2>
						<p>
							We may update this policy. Changes are effective when posted here.
							Please review this policy periodically.
						</p>

						<h2>7. Contact Us</h2>
						<p>If you have questions, please contact us at: mis.stf05@lnl.co.di</p>
						<p>
							PT. Lautan Natural Krimerindo
							<br />
							Jl. Mojosari - Pacet No.Km. 4, Mojojejer, Pesanggrahan, Kec. Kutorejo,
							Kabupaten Mojokerto, Jawa Timur 61383, Indonesia
						</p>
					</CardBody>
				</Card>

				<div className='col-12 d-flex flex-column justify-content-center align-items-center pb-5'>
					<Button
						className='px-5 py-3 mt-3'
						color='primary'
						isLight
						icon='HolidayVillage'
						tag='a'
						href='/'>
						Homepage
					</Button>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default PrivacyPolicy;
